/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useBitKeepContext } from "@/components/BitKeepProvider";
import { supportedCurrencies, currenyInfo } from "./config";
const url = "https://embed.bitrefill.com/";
function MyBitrefillWidget() {
    const config = {
        ref: "wYJlhN05",
        paymentMethods: supportedCurrencies.join(","),
        utm_source: "BitgetWallet"
    };
    const { bitkeep } = useBitKeepContext();
    useEffect(()=>{
        window.addEventListener("message", handleMessage);
        return ()=>{
            window.removeEventListener("message", handleMessage);
        };
    }, []);
    const handleMessage = (e)=>{
        if (e.origin !== "https://embed.bitrefill.com") {
            return;
        }
        const data = JSON.parse(e.data);
        const { event, paymentAddress, paymentAmount, paymentMethod } = data;
        console.log(e, JSON.parse(e.data), currenyInfo[paymentMethod], 89898);
        switch(event){
            case "payment_intent":
                var _currenyInfo_paymentMethod, _currenyInfo_paymentMethod1, _currenyInfo_paymentMethod2, _currenyInfo_paymentMethod3;
                // Pay the users invoice with the `paymentUri`
                console.log("payment_intent");
                bitkeep.jumpUrl(paymentMethod === "lightning" ? "bitkeep://lightingtranfer?chain=".concat((_currenyInfo_paymentMethod = currenyInfo[paymentMethod]) === null || _currenyInfo_paymentMethod === void 0 ? void 0 : _currenyInfo_paymentMethod.chain, "&contract=").concat((_currenyInfo_paymentMethod1 = currenyInfo[paymentMethod]) === null || _currenyInfo_paymentMethod1 === void 0 ? void 0 : _currenyInfo_paymentMethod1.contract, "&to=").concat(paymentAddress, "&amount=").concat(paymentAmount) : "bitkeep://tranfer?chain=".concat((_currenyInfo_paymentMethod2 = currenyInfo[paymentMethod]) === null || _currenyInfo_paymentMethod2 === void 0 ? void 0 : _currenyInfo_paymentMethod2.chain, "&contract=").concat((_currenyInfo_paymentMethod3 = currenyInfo[paymentMethod]) === null || _currenyInfo_paymentMethod3 === void 0 ? void 0 : _currenyInfo_paymentMethod3.contract, "&to=").concat(paymentAddress, "&amount=").concat(paymentAmount));
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ _jsx("iframe", {
        title: "Bitrefill",
        src: "".concat(url, "?").concat(new URLSearchParams(config)),
        style: {
            width: "100%",
            height: "100%",
            border: "none"
        },
        sandbox: "allow-same-origin allow-popups allow-scripts allow-forms"
    });
}
export default MyBitrefillWidget;
